export default __webpack_public_path__ + "static/media/expert-1.bee55d43.png";